import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormsySelect } from 'formsy-material-ui';

class SelectField extends Component {

    render() {
    	const hintText = this.props.hintText + (this.props.required ? " *" : "");
    	const floatingLabelText = this.props.floatingLabelText + (this.props.required ? " *" : "");
        return (
            <FormsySelect 
                {...this.props} 
            	className="input-field select" 
            	floatingLabelText={floatingLabelText} 
            	hintText={hintText} 
            	fullWidth={true}
            >
                {this.props.children}
            </FormsySelect>
        );
    }
}

SelectField.propTypes = {
    hintText:           PropTypes.string,
    floatingLabelText:  PropTypes.string.isRequired,
    required:           PropTypes.bool
};

SelectField.defaultProps = {
    hintText:   ''
};

export default SelectField;
//floatingLabelStyle={ { marginLeft: '20px' } }
